import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WclApi, WclService } from '@compumark/analyst-selection-tool-client';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-wcl-engine-settings',
  standalone: false,
  templateUrl: './wcl-engine-settings.component.html',
  styleUrls: ['./wcl-engine-settings.component.scss'],
})
export class WCLEngineSettingsComponent implements OnInit {
  wclApis: WclApi[] = [];
  activeEngine: string | null = null;

  constructor(private wclService: WclService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.wclApis = this.route.snapshot.data.data.wclApis;
    this.activeEngine = this.wclApis.find((api) => api.active)?.name || null;
  }

  onEngineSelectionChange(selectedEngine: string): void {
    if (!selectedEngine || selectedEngine === this.activeEngine) {
      return;
    }

    this.wclService
      .setActiveWclApi(selectedEngine)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.wclApis.forEach((api) => {
            api.active = api.name === selectedEngine;
          });
          this.activeEngine = selectedEngine;
        },
        error: (error) => {
          console.error('Error updating WCL API status:', error);
        },
      });
  }
}
